import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let token = window.localStorage.getItem("token");
let solde = window.localStorage.getItem("solde");

export default new Vuex.Store({
  state: {
    tokens: token ? JSON.parse(token) : [],
    soldes: solde ? JSON.parse(solde) : []
  },
  mutations: {
    addToken(state, token) {
      state.tokens.push(token);
      this.commit("saveData");
    },
    removeToken(state, token) {
      let token1 = state.tokens.indexOf(token);
      state.tokens.splice(token1, 1);
      this.commit("saveData");
    },
    addSolde(state, solde) {
      state.soldes.push(solde);
      this.commit("saveData");
    },
    removeSolde(state, solde) {
      let solde1 = state.soldes.indexOf(solde);
      state.soldes.splice(solde1, 1);
      this.commit("saveData");
    },
    saveData(state) {
      window.localStorage.setItem("token", JSON.stringify(state.tokens));
      window.localStorage.setItem("solde", JSON.stringify(state.soldes));
    }
  }
});
